import { toBlob } from 'html-to-image';

// Use html-to-image's `toBlob` which produces a Blob via `canvas.toBlob` —
// avoids `fetch('data:...')`, which is blocked by strict `connect-src` CSP
// on the deployed environment and throws `TypeError: Failed to fetch`.
export async function captureElementAsBlob(
  element: HTMLElement,
  format: 'png' | 'jpeg' = 'png'
): Promise<Blob> {
  const options = {
    cacheBust: true,
    backgroundColor: '#ffffff',
    type: format === 'jpeg' ? 'image/jpeg' : 'image/png',
    ...(format === 'jpeg' ? { quality: 0.95 } : {}),
  };

  const blob = await toBlob(element, options);
  if (!blob) {
    throw new Error('Failed to generate chart image');
  }
  return blob;
}
